import { BaseComponent } from '../../../components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { ChevronRight } from 'react-feather';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Modal } from '../../../components/Modal';
import { Loader } from '../../../components/Loader';
import { Home, Left } from '../../../components/Icon';
import { PageHeader } from '../../../components/PageHeader';
import { StepperCreateHeader } from '../../Vehicles/pages/create/Header';
import { CompanyCreateStep1 } from './FirstStep/FirstStep';
import { CompanyCreateStep2 } from './SecondStep/SecondStep';
import { CompanyCreateStep3 } from './ThirdStep/ThirdStep';
import { CompanyCreateInfo } from './CompanyCreateInfoCard';
import ButtonComponent from '../../../containers/App/Components/Button/Button';
import cn from 'classnames';
import styles from './editInner.module.css';
import { DoubleVATModal } from '../components/DoubleVATModal';
import { updateCompanyProperties, initiateCompanyEdit, setNewCompanyValue, fetchCompany } from '../actions';
import { selectAddressTypes } from '../../Address/selectors';
import { selectWorks } from '../../Api/selectors';
import { selectNewCompany, selectNewCompanyAddresses } from '../selectors';
import {
  CREATE_REQUIRED_FIELDS_TYPE_COMPANY,
  CREATE_REQUIRED_FIELDS_TYPE_INDIVIDUAL,
  REQUEST_COMPANY,
  REQUEST_COMPANY_PROPERTY_UPDATE,
  REQUEST_COUNTRIES,
} from '../constants';
import { VAT_DUPLICATE_MESSAGE } from './../../../utils/request';
import { AnalyseStep4 } from './FourthAnalyseStep/FourthAnalyseStep';
import ModalComponent from '../../../containers/App/Components/Modal/Modal';
import env from '../../../env';
import { AppClientId } from '../../Shared/constants';
import LoadingFilters from '../../../containers/App/Components/LoadingFilters/LoadingFilters';

const Container = styled.div`
  .create-company-info-card {
    margin-left: auto;
  }

  .form-block {
    display: flex;
    align-items: stretch;
    flex-direction: row;
    gap: 3px;

    @media (max-width: 768px) {
      flex-direction: column;
      align-items: center;
    }
  }

  .pane {
    background-color: white;
    padding: 24px;
    min-height: 800px;
    height: 100%;

    h2 {
      font-size: 14px;
      text-transform: uppercase;
    }

    @media (max-width: 768px) {
      min-height: auto;
    }

    h2 {
      margin-bottom: 24px;
    }

    .cols {
      gap: 48px;
      align-self: stretch;
    }
  }
`;

const STATE = {
  addresses: [],
  stepperClickStep: null,
  stepperClick: false,
  showCompanyInfo: false,
};

/* eslint-disable react/prefer-stateless-function */
class CompanyEditInnerComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    this.props.init();
  }

  get company() {
    return this.props.company;
  }

  get isSkipVATCheking() {
    let skip = false;

    if (this.company?.BTW_number === this.props.values?.['BTW_number']) {
      skip = true;
    }
    return skip;
  }

  get stepsData() {
    let stepsData = {
      steps: 3,
      labels: ['Relatie info', 'Financiele data', 'Contacten'],
    };

    if (env.clientId === AppClientId.INDEWAL && this.props.company_id) {
      stepsData.steps = 4;
      stepsData.labels.push('Analyse');
    }

    return stepsData;
  }

  save(options) {
    if (this.requiredFields?.length) return;
    const addressProps = { addressLine1: '', postcode: '', city: '', countryId: '' };
    const requestBodyTypes = { addressLine1: '', postcode: '', city: '', countryId: '', accountManagerId: '' };
    let addressTypeId = null;
    let newAddress = {};

    let prop = {
      properties: [],
      addresses: [],
      accountManagerId: this.props.values.accountManagerId || null,
    };

    if (this.props.step === 1) {
      addressTypeId = this.props.addressTypes.filter(t => t.name === 'home')[0].id;
      newAddress['id'] = this.props.values?.addresses?.filter(a => a.typeId === addressTypeId)[0]?.id;
    }

    if (this.props.step === 2) {
      addressTypeId = this.props.addressTypes.filter(t => t.name === 'invoice')[0].id;
      newAddress['id'] = this.props.values?.addresses?.filter(a => a.typeId === addressTypeId)[0]?.id;
    }

    if (this.props.step === 3) {
      this.props.fetchCompany(this.props.company_id, fetchResult => {
        if (fetchResult) {
          this.state.stepperClick
            ? this.to(`/companies/${fetchResult.id}/edit/${this.state.stepperClickStep}`)
            : this.to(`/companies/${fetchResult.id}/edit/4`);
          return this.setState({ stepperClick: false });
        }
      });
    }

    for (let i in this.props.values) {
      if (
        [
          'invoice_to_main_address',
          'release_before_incoming_transport',
          'release_before_outgoing_transport',
          'exact_sync_to_parent',
        ].includes(i)
      ) {
        prop.properties.push({
          name: i,
          value: this.props.values[i] || false,
        });
      } else if (this.props.values[i] && i == 'BTW_number') {
        prop.properties.push({
          name: i,
          value: this.props.values[i].replace(/\s/g, '')?.toUpperCase(),
        });
      } else if (this.props.values[i] != '' && i != 'addresses' && !Object.keys(requestBodyTypes).includes(i)) {
        this.props.values[i] &&
          prop.properties.push({
            name: i,
            value: this.props.values[i],
          });
      }
    }

    for (let i in addressProps) {
      if (this.props.values[i] != '') {
        newAddress[i] = this.props.values[i];
        newAddress['typeId'] = addressTypeId;
      }
    }

    if (this.props.step == 1 || this.props.step == 2) {
      let editAddresses = [];
      try {
        Object.keys(newAddress).length > 1
          ? (editAddresses = [...this.props.values?.addresses, newAddress])
          : (editAddresses = [...this.props.values?.addresses]);
      } catch (e) {}

      this.props.patch(
        prop.properties,
        editAddresses,
        prop.accountManagerId,
        result => {
          if (result?.data?.message?.toLowerCase() === VAT_DUPLICATE_MESSAGE?.toLowerCase()) {
            this.setState({
              showDoubleVATModal: true,
              matchedCompaniesIds: result?.data?.matchedCompaniesIds,
            });
          }
          if (result.id) {
            this.setState(prevState => ({
              ...this.state,
              addresses: result.addresses,
            }));
            this.state.stepperClick
              ? this.props.fetchCompany(this.props.company_id, fetchResult => {
                  fetchResult && this.to(`/companies/${result.id}/edit/${this.state.stepperClickStep}`);
                })
              : this.props.fetchCompany(this.props.company_id, fetchResult => {
                  fetchResult && this.props.nextStep();
                });
          }

          this.setState({ stepperClick: false });
        },
        this.isSkipVATCheking || options?.skipVatUniquenessCheck,
      );
    }

    if (this.props.step == 4) {
      this.props.fetchCompany(this.props.company_id, fetchResult => {
        fetchResult &&
          this.props.patch(prop.properties, fetchResult.addresses, prop.accountManagerId, result => {
            this.setState(prevState => ({
              ...this.state,
              addresses: result.addresses,
            }));
            this.state.stepperClick
              ? this.to(`/companies/${this.props.company_id}/edit/${this.state.stepperClickStep}`)
              : this.props.nextStep();
            return this.setState({ stepperClick: false });
          });
      });
    }
  }

  getStep(n) {
    n && this.setState({ stepperClickStep: n, stepperClick: true });
  }

  prevStep() {
    if (this.requiredFields?.length) return;
    this.props.prevStep();
  }
  nextStep() {
    if (this.requiredFields?.length) return;
    this.props.nextStep();
  }

  toggleCompanyInfo = () => {
    this.setState(prevState => ({ showCompanyInfo: !prevState.showCompanyInfo }));
  };

  onCancelDoubleVATModal() {
    this.setState({
      showDoubleVATModal: false,
      matchedCompaniesIds: [],
    });
  }

  get requiredFields() {
    if (env.clientId !== AppClientId.AUTOWIENTJES) return [];
    const types =
      this.props.values.company_type === 'company'
        ? CREATE_REQUIRED_FIELDS_TYPE_COMPANY
        : CREATE_REQUIRED_FIELDS_TYPE_INDIVIDUAL;

    if (this.props.step !== 1) return [];
    return types.filter(type => !this.props.values[type]);
  }

  reset() {
    this.props.resetValues(this.props.values);
  }

  render() {
    if (this.props.values.id != this.props.company_id) return <Loader small="true" />;
    const flexBoxClass = cn(
      styles.flexBox,
      {
        [styles.flexBoxPage1]: this.props.step === 1 || this.props.step === 2,
      },
      'form-block',
    );

    if (window.innerWidth >= 1024 && this.props.work) {
      return (
        <>
          <div className="container-fluid p-0">
            <PageHeader
              title={
                <>
                  <Home />
                  {this.lbl('company.overview.title')}
                </>
              }
            ></PageHeader>
            <LoadingFilters />
          </div>
        </>
      );
    }

    return (
      <Container>
        {this.state.showDoubleVATModal && this.state.matchedCompaniesIds?.[0] && (
          <DoubleVATModal
            onSave={() => this.save({ skipVatUniquenessCheck: true })}
            onCancel={this.onCancelDoubleVATModal.bind(this)}
            existsCompanyId={this.state.matchedCompaniesIds[0]}
          />
        )}
        {this.props.work ? <Loader /> : null}
        <PageHeader
          title={
            <div className="pointer" onClick={this.tofn(`/companies/${this.company.id}`)}>
              <Left />
              {this.lbl('companies')}
            </div>
          }
          breadCrumbs={
            <>
              <a href="/">Vindat</a>
              <ChevronRight />
              {this.lbl('companies')}
              <ChevronRight />

              {this.lbl('add')}
            </>
          }
        />
        <StepperCreateHeader
          edit
          steps_quantity={this.stepsData?.steps}
          model={'company'}
          model_id={this.props.company_id}
          labelArr={this.stepsData?.labels}
          step={this.props.step}
          onSave={this.save.bind(this)}
          getStep={this.getStep.bind(this)}
          onIncrement={this.prevStep.bind(this)}
          onDecrement={this.nextStep.bind(this)}
        />

        <div className={flexBoxClass}>
          {window.innerWidth <= 768 && this.props.step > 1 && (
            <div className={styles.buttonCompanyInfo}>
              <ButtonComponent style="ButtonSoftPrimary" onClick={this.toggleCompanyInfo}>
                {this.lbl(`vehicle.info.data.vehicle_info`)}
              </ButtonComponent>
            </div>
          )}

          {this.state.showCompanyInfo && this.props.company_id && (
            <CompanyCreateInfo
              company_id={this.props.company_id}
              data={['company_type', 'name', 'surname', 'phone_number', 'company_email', 'email']}
            />
          )}

          {this.props.step === 1 && (
            <CompanyCreateStep1
              company_id={this.props.company_id}
              onSave={this.save.bind(this)}
              company={this.company}
              reset={this.reset.bind(this)}
            />
          )}
          {this.props.step === 2 && (
            <CompanyCreateStep2
              company_id={this.props.company_id}
              onSave={this.save.bind(this)}
              getPrevStep={this.prevStep.bind(this)}
            />
          )}
          {this.props.step === 3 && (
            <CompanyCreateStep3
              company_id={this.props.company_id}
              onSave={this.save.bind(this)}
              getPrevStep={this.prevStep.bind(this)}
            />
          )}
          {this.props.step === 4 && env.clientId === AppClientId.INDEWAL && (
            <AnalyseStep4
              company_id={this.props.company_id}
              onSave={this.save.bind(this)}
              getPrevStep={this.prevStep.bind(this)}
            />
          )}

          {/* {this.props.step === 4 && (
            <CompanyCreateStep4
              company_id={this.props.company_id}
              addresses={this.state.addresses}
              onSave={this.save.bind(this)}
              getPrevStep={this.prevStep.bind(this)}
            />
          )} */}

          {/* {this.props.step > 1 && this.props.company_id && window.innerWidth > 769 && (
            <CompanyCreateInfo
              company_id={this.props.company_id}
              data={['company_type', 'name', 'surname', 'phone_number', 'company_email', 'email']}
            />
          )} */}
        </div>
      </Container>
    );
  }
}

CompanyEditInnerComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([REQUEST_COMPANY, REQUEST_COMPANY_PROPERTY_UPDATE, REQUEST_COUNTRIES]),
    values: selectNewCompany(),
    addressess: selectNewCompanyAddresses(),
    addressTypes: selectAddressTypes(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    init() {
      dispatch(initiateCompanyEdit(ownProps.company_id));
    },

    patch(props, addresses, accountManagerId, callback, skipVatUniquenessCheck) {
      dispatch(
        updateCompanyProperties(ownProps.company_id, props, addresses, accountManagerId, callback, skipVatUniquenessCheck),
      );
    },
    fetchCompany(id, callback) {
      dispatch(fetchCompany(id, callback));
    },
    resetValues(values, name = null) {
      Object.keys(values)?.map(type => dispatch(setNewCompanyValue(type, '')));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const CompanyEditInner = compose(withConnect, withRouter)(CompanyEditInnerComp);
